import request from '@/utils/request'

let uacApi = {
  /*项目列表*/
  list(data, errorback) {
    return request._post('/shop/plus.cashdesk.Index/index', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.cashdesk.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.cashdesk.Setting/getSetting', data, errorback);
  },
  getCategory(data, errorback) {
    return request._get('/shop/plus.cashdesk.Index/getCategory', data, errorback);
  },
  getProduct(data, errorback) {
    return request._get('/shop/plus.cashdesk.Index/getProduct', data, errorback);
  },
  getProductDetail(data, errorback) {
    return request._get('/shop/plus.cashdesk.Index/getProductDetail', data, errorback);
  },
  addCart(data, errorback) {//添加数据到购物车
    return request._get('/shop/plus.cashdesk.Index/addCart', data, errorback);
  },
  addCartByBarcodenum(data, errorback) {//添加数据到购物车-根据条形码
    return request._get('/shop/plus.cashdesk.Index/addCartByBarcodenum', data, errorback);
  },
  getStore(data, errorback) {//获取门店信息
    return request._get('/shop/plus.cashdesk.Index/getStore', data, errorback);
  },
  getCartList(data, errorback) {//获取购物车数据
    return request._get('/shop/plus.cashdesk.Index/getCartList', data, errorback);
  },
  delCart(data, errorback) {//删除购物车
    return request._get('/shop/plus.cashdesk.Index/delCart', data, errorback);
  },
  getCartPlacement(data, errorback) {//获取挂单位置
    return request._get('/shop/plus.cashdesk.Index/getCartPlacement', data, errorback);
  },
  addCartPlacement(data, errorback) {//添加购物车商品到挂单位置
    return request._get('/shop/plus.cashdesk.Index/addCartPlacement', data, errorback);
  },
  takeCartPlacement(data, errorback) {//挂单取单
    return request._get('/shop/plus.cashdesk.Index/takeCartPlacement', data, errorback);
  },
  getUser(data, errorback) {//查询会员
    return request._get('/shop/plus.cashdesk.Index/getUser', data, errorback);
  },
  relatedUser(data, errorback) {//关联会员到购物车
    return request._get('/shop/plus.cashdesk.Index/relatedUser', data, errorback);
  },
  canelRelatedUser(data, errorback) {//切换游客
    return request._get('/shop/plus.cashdesk.Index/canelRelatedUser', data, errorback);
  },
  buy(data, errorback) {//创建订单
    return request._get('/shop/plus.cashdesk.Index/buy', data, errorback);
  },
}
export default uacApi;



// WEBPACK FOOTER //
// ./src/api/cashdesk.js